<template>
  <section>
    <div class="content-wrapper main-container">
      <errors v-if="isVisibleErrorsModal"></errors>

      <div class="content-heading">
        All users
        <small data-localize="dashboard.WELCOME"></small>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div id="panelChart9" class="panel panel-default">

          <div class="search-area">
            <form role="form" class="mb-xl top-margin form-row" novalidate>
              <div class="form-group has-feedback searchbox">
                <div tabindex="0" @click="toggleIsSearchOpen" @blur="isSearchOpen = false" class="dropdown" :class="isSearchOpen ? 'dropdown-open' : 'dropdown-closed'">
                  <h4 v-if="!isSearchOpen" class="current-search-by">{{currentSearchByDisplay}}<i class="fa fa-caret-down" aria-hidden="true"></i></h4>
                  <h4 v-else class="current-search-by" id="filter-by">Filter by</h4>
                  <ul class="dropdown-content">
                    <li
                      class="search-option"
                      v-for="searchType in searchTypes"
                      :key="searchType.name"
                      @click="updatedSearchingBy(searchType)">
                      <i class="fa fa-check" aria-hidden="true" :class="currentSearchByDisplay !== searchType.displayName ? 'transparent-text' : ''"></i>
                      {{searchType.displayName}}
                    </li>
                  </ul>
                </div>
                <div class="search-holder">
                  <input
                    v-model="search"
                    id="search"
                    ref="searchInput"
                    type="text"
                    placeholder="Enter your search here..."
                    autocomplete="off"
                    class="form-control"
                    @focus="onSearchFocus"
                    @blur="onSearchBlur"/>
                  <p v-if="hasSearched || search" id="clear-icon" @click="clearSearch">X</p>
                </div>
                <button type="submit" class="btn btn-default btn-lg" v-bind:disabled="disableSubmitSearch" v-on:click="searchInvestors"><em class="icon-magnifier pr-sm"></em> Search</button>
                <button type="submit" class="btn btn-success btn-lg" v-on:click="goToCreateUser()"><em class="icon-user-follow pr-sm"></em> Create new user</button>
              </div>

            </form>
            <recent-records :visible="isSearchFocused" />
          </div>
          <spinner class="table-spinner" v-if="isSearchLoading" ></spinner>
            <div v-else class="panel-heading">
              <div v-if="areResultsEmpty && !isSearchLoading" class="panel-body">
               <div class="alert alert-info alert-dismissible mt-lg" role="alert">
                  <section class="search-message--no-result">
                    <i class="fa fa-window-close-o"></i>
                    <h4>No results found for "{{searchMessage}}"</h4>
                    <p>Make sure your text is spelled correctly or try with a different keyword.</p>
                  </section>
               </div>
             </div>
             <div v-else-if="!hasSearched && !isSearchLoading">
              <section class="search-message--empty">
                <i class="fa fa-search"></i>
                <h4>You can search by:</h4>
                <ul>
                  <li>Name / email - using investor's name, account name or email</li>
                  <li>Advisor firm - using company name 1 or company name 2</li>
                  <li>Note number or CUSIP</li>
                  <li>Account number</li>
                </ul>
              </section>
             </div>
             <div v-else>
              <div v-if="results" class="table-responsive top-margin">
                <search-by-account-results
                  :results="results"
                  :searchMessage="searchMessage"
                  v-if="searchingBy === 'ACCOUNT_NUMBER'"
                />
                <search-by-name-or-email-results
                  :results="results"
                  :searchMessage="searchMessage"
                  :show-company-names="searchingBy === 'ADVISOR_FIRM'"
                  v-if="searchingBy === 'NAME_EMAIL' || searchingBy === 'ADVISOR_FIRM'"
                />
                <search-by-note-number-or-cusip-results
                :results="results"
                :searchMessage="searchMessage"
                v-if="searchingBy === 'NOTE_NUMBER' || searchingBy === 'CUSIP'"
                />
              </div>
             </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    mapActions,
    mapMutations,
    mapState,
  } from 'vuex';

  import { find } from 'lodash';
  import Errors from '@/components/modals/Errors';
  import RecentRecords from '@/components/RecentRecords';
  import spinner from '@/components/widgets/Spinner';
  import SearchByAccountResults from '@/components/SearchByAccountResults';
  import SeachByNameOrEmailResults from '@/components/SearchByNameOrEmailResults';
  import SearchByNoteNumberOrCUSIPResults from '@/components/SearchByNoteNumberOrCUSIPResults';
  import { SearchTypes } from '@/data/static/searchTypes';
  import {
    SET_ERRORS_MODAL_INFO,
    SHOW_ERRORS_MODAL,
    SET_SEARCH_STRING,
    SET_CURRENTLY_SEARCHING_BY,
  } from '@/store/mutation-types';

  export default {
    name: 'investorList',
    beforeMount() {
      this.setParams();
      this.searchInvestors();
    },
    components: {
      errors: Errors,
      'recent-records': RecentRecords,
      'search-by-account-results': SearchByAccountResults,
      'search-by-name-or-email-results': SeachByNameOrEmailResults,
      'search-by-note-number-or-cusip-results': SearchByNoteNumberOrCUSIPResults,
      spinner,
    },
    data() {
      return {
        results: {},
        hasSearched: false,
        search: '',
        investorError: '',
        searchTypes: SearchTypes,
        searchingBy: '',
        isSearchOpen: false,
        isSearchLoading: false,
        searchMessage: '',
        isSearchFocused: false,
      };
    },
    computed: {
      ...mapState('errors', [
        'isVisibleErrorsModal',
      ]),
      ...mapState('user', [
        'disableSubmitSearch',
        'searchString',
        'currentlySearchingBy',
      ]),
      isNotesEmpty() {
        return this.results.notes ? !this.results.notes.length : true;
      },
      isAccountsEmpty() {
        return this.results.accounts ? !this.results.accounts.length : true;
      },
      isUsersEmpty() {
        return this.results.users ? !this.results.users.length : true;
      },
      isAccountEmpty() {
        return !this.results.account;
      },
      areResultsEmpty() {
        return this.isNotesEmpty && this.isAccountEmpty && this.isAccountsEmpty
          && this.isUsersEmpty && this.hasSearched;
      },
      currentSearchByDisplay() {
        const currentlySearchingBy = find(SearchTypes,
          searchType => searchType.name === this.searchingBy,
        );
        return currentlySearchingBy.displayName;
      },
    },
    methods: {
      ...mapActions('user', [
        'getInvestors',
        'storeUserInSessionStorage',
      ]),
      ...mapActions('account', [
        'getAccounts',
      ]),
      ...mapMutations('errors', {
        showErrorsModal: SHOW_ERRORS_MODAL,
        setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
      }),
      ...mapMutations('user', {
        setSearchString: SET_SEARCH_STRING,
        setCurrentlySearchingBy: SET_CURRENTLY_SEARCHING_BY,
      }),
      setParams() {
        this.search = this.searchString;
        this.searchingBy = this.currentlySearchingBy;
      },
      goToCreateUser() {
        this.$router.push({ name: 'UserCreationByAdmin' });
      },
      async searchInvestors(e) {
        if (e) {
          e.preventDefault();
        }
        if (this.$refs.searchInput) {
          this.$refs.searchInput.blur();
        }
        if (this.search) {
          this.startSearch();
          return this.getAccounts({ searchString: this.search, searchBy: this.searchingBy })
            .then((data) => {
              this.searchMessage = this.search;
              this.hasSearched = true;
              if (data.statusCode === 401) {
                this.results = {};
              } else {
                this.results = data;
              }
              this.isSearchLoading = false;
            })
            .catch(() => {
              this.setErrorsModalInfo(['We could not retrieve investors list']);
              this.showErrorsModal();
              this.isSearchLoading = false;
            });
        }
        return Promise.resolve();
      },
      startSearch() {
        this.results = {};
        this.isSearchLoading = true;
        this.setSearchString(this.search);
        this.setCurrentlySearchingBy(this.searchingBy);
      },
      updatedSearchingBy(searchBy) {
        if (this.searchingBy !== searchBy.name) {
          this.searchingBy = searchBy.name;
          this.hasSearched = false;
        }
      },
      toggleIsSearchOpen() {
        this.isSearchOpen = !this.isSearchOpen;
      },
      onSearchFocus() {
        this.isSearchFocused = true;
      },
      onSearchBlur() {
        this.isSearchFocused = false;
      },
      clearSearch(e) {
        if (e.target.id === 'clear-icon') {
          this.search = '';
          this.hasSearched = false;
          this.accounts = [];
          this.investors = [];
          this.setSearchString('');
        }
      },
    },
  };
</script>

<style scoped>
  .main-container {
    padding-top: 5;
  }

  .search-area {
    position: relative;
  }

  .notes-list-title {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .content-heading {
    font-weight: normal;
  }

  .top-margin {
    margin-top: 2%;
  }

  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }

  .panel-default {
    padding: 20px 30px;
    min-height: 400px;
  }

  .panel-heading {
    color: #444;
    background-color: #ffffff;
    border-color: #cfdbe2;
    border-bottom: 0;
    font-size: 14px;
    padding: 0px 5px;
  }

  table {
    border-collapse: collapse;
  }

  th {
    padding: 14px 8px;
    color: #888;
    border-bottom-width: 1px;
    vertical-align: bottom;
    border-bottom: 1px solid #eee;
    border-top: 0;
    line-height: 1.52857143;
    font-weight: normal;
  }

  td {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }

  .table-striped>tbody>tr:nth-of-type(odd) {
    background-color: #fafbfc;
  }

  .panel-body {
    padding: 0;
  }

  .searchbox {
    display: flex;
    flex-direction: row;
  }

  .searchbox input {
    height: 39px;
    flex: 1;
    border-radius: 4px 0 0 4px;
  }

  .searchbox .btn-default {
    text-align: center;
    margin-right: 16px;
    border-radius: 0 4px 4px 0;
  }

  .btn-lg {
    height: 39px;
  }

  .panel-title {
    font-weight: 400;
  }

  .table-responsive {
    font-weight: 400;
  }

  .table-responsive {
    border-top: 1px solid #cecece;
    padding-top: 5px;
  }

  .table-responsive td {
    color: #211915;
  }

  .breadcrumb {
    background: transparent;
  }

  .breadcrumb-item a {
    color: #00788D;
  }

  .breadcrumb-item + .breadcrumb-item::before {
    display: inline-block;
    padding-right: .5rem;
    color: #00788D;
    content: "›";
  }

  .search-message--no-result,
  .search-message--empty {
    background: rgba(224, 240, 243, 0.5);
    border: 1px solid #BEE5EB;
    padding: 40px 20px;
    margin: 10px auto;
    text-align: center;
    color: #00788D;
  }
  .search-message--no-result h4,
  .search-message--empty h4 {
    font-size: 20px;
  }
  .search-message--no-result i,
  .search-message--empty i {
    font-size: 100px;
    margin-bottom: 20px;
  }
  .search-message--no-result ul,
  .search-message--empty ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .search-message--no-result ul, .search-message--no-result p,
  .search-message--empty ul,
  .search-message--empty p {
    font-size: 16px;
  }

  .dropdown {
    color: #969696;
    background-color: #eeeeee;
    border: 1px solid #cccccc;
    position: absolute;
  }

  .dropdown:hover{
    cursor: pointer;
  }

  .dropdown-closed {
    max-height: 39px;
    height: 39px;
    overflow-y: hidden;
    padding: 0 5px;
    min-width: 120px
  }

  .dropdown-open {
    max-height: initial;
    height: initial;
    overflow-y: show;
    padding-right: 30px;
    min-width: 150px
  }

  #search {
    border-radius: 0;
    height: 36px;
    border: none;
  }

  .current-search-by {
    font-weight: 400;
    font-size: 14px;
    text-align: center;
  }

  .current-search-by i {
    margin-left: 7px;
  }

  #filter-by {
    text-align: left;
    padding-left: 20px;
  }

  .search-option {
    list-style-type: none;
    margin-left: -39px;
    margin-bottom: 5px;
  }

  .search-option:hover{
    cursor: pointer;
  }

  .fa-check {
    margin-right: 5px;
  }

  #search {
    width: 100%;
  }

  .search-holder{
    border: 1px solid #DDD;
    border-left: none;
    display:flex;
    height: 37px;
    box-sizing: initial;
    width: 100%;
    margin-left: 137px;
  }

  #clear-icon {
    padding: 10px 10px 0 0;
    font-weight: 400;
    color: #606062;
  }

  #clear-icon:hover{
    cursor: pointer;
  }

  .table-spinner {
    position: initial;
  }

  .transparent-text {
    color: transparent;
  }
</style>



// WEBPACK FOOTER //
// Users.vue?368b3ccc